var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-layout"},[_c('div',[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('logout.message'),expression:"'logout.message'"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }